import { Box, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	label: string;
	active: boolean;
	onClick: () => void;
};

export const ReminderPresetChip: FC<Props> = ({ label, active, onClick }) => {
	const { palette } = useTheme();

	return (
		<Box
			component="button"
			type="button"
			onClick={onClick}
			borderRadius={"9999px"}
			border={`1.5px solid ${active ? palette.blue[600] : palette.grey[200]}`}
			bgcolor={active ? palette.blue[50] : "transparent"}
			py={0.8}
			px={1.4}
			sx={{ cursor: "pointer" }}
		>
			<Typography
				variant="button"
				color={active ? palette.blue[700] : palette.grey[500]}
			>
				{label}
			</Typography>
		</Box>
	);
};
